import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Switch,
  IconButton,
  Typography,
  colors,
} from "@material-ui/core";
import {
  Edit as EditIcon,
  Download as DownloadIcon,
  Print,
  Receipt,
  Description,
  FitnessCenter,
  Favorite,
  Code,
} from "@material-ui/icons";
import TemplateTest from "./test-template";
import PrintingButtons from "../../../../components/controls/PrintingButtons";
import AddTemplate from "./AddTemplate";
import { uri } from "../../../../help/Api";
// import AddTemplate from "./AddTemplate"; // Make sure the AddTemplate component is in the same directory
// import InvoiceHome from "../../pages/test-templater";
export const TemplateIcons = [
  { name: "Print", component: Print },
  { name: "Receipt", component: Receipt },
  //   { name: "School", component: School },
  { name: "Discription", component: Description },
  { name: "FitnessCenter", component: FitnessCenter },
  { name: "Favorite", component: Favorite },
  { name: "Code", component: Code },
];
const TemplateTable = () => {
  const [templates, setTemplates] = useState([]);
  const [editingTemplate, setEditingTemplate] = useState(null);

  useEffect(() => {
    fetchTemplates();
  }, []);

  const fetchTemplates = async () => {
    try {
      const response = await axios.get(`${uri}templates`);
      setTemplates(response.data);
    } catch (error) {
      console.error("Error fetching templates", error);
    }
  };

  const handleEdit = (template) => {
    setEditingTemplate(template);
  };

  const handleDownload = async (fileName) => {
    try {
      const response = await axios.get(
        `${uri}PrintTemplates/download-template/${fileName}`,
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error downloading file", error);
    }
  };

  const handleUpdateComplete = () => {
    setEditingTemplate(null);
    fetchTemplates();
  };
  const SelectedIconComponent = (selectedIcon) => {
    const IconCompo =
    TemplateIcons.find((icon) => icon.name === selectedIcon)?.component || null;
    return IconCompo != null ? <IconCompo /> : <></>;
  };
  return (
    <div >
      {editingTemplate ? (
   
        <AddTemplate
          existingTemplate={editingTemplate}
          onSubmit={handleUpdateComplete}
        />
      ) : (
        <TableContainer component={Paper}>
          <Table aria-label="a dense table">
            <TableHead>
              <TableRow style={{
              backgroundColor: colors.teal[100],
              color: "#fff",
            }}>
                <TableCell>Template Name</TableCell>
                <TableCell>Template Icon</TableCell>
                {/* <TableCell>State</TableCell> */}
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {templates.map((template) => (
                <TableRow key={template.Id}>
                  <TableCell>{template.Name}</TableCell>
                  <TableCell>
                    {template.IconName && (
                      <div style={{ marginTop: "5px", textAlign: "center" }}>
                        {SelectedIconComponent(template.IconName)}
                      </div>
                    )}
                    {/* {SelectedIconComponent && (
                      <div style={{ marginTop: "20px", textAlign: "center" }}>
                        <SelectedIconComponent selectedIcon={template.iconName} style={{ fontSize: 40 }} />
                      </div>
                    )} */}
                  </TableCell>
                  {/* <TableCell>
                    <Switch checked={template.State} readOnly color="primary" />
                  </TableCell> */}
                  <TableCell>
                    <Button variant="text" onClick={() => handleEdit(template)}>
                      تعديل القالب
                    </Button>
                    <Button
                      variant="text"
                      onClick={() => handleDownload(template.FileName)}
                    >
                      تحميل القالب
                    </Button>
                    <TemplateTest fileName={template.FileName} 
                    invoiceData={{proc_id:88, branchId:1, procTypeInvProc:"02", title:"فـاتـورة مـبـيـعـات"}} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};

export default TemplateTable;

// const TemplateTable = ({ templates, onEdit }) => {
//   const handleDownload = (id) => {
//     const fileUrl = `http://localhost:8189/api/PrintTemplates/download-template/${id}`;
//     axios({
//       url: fileUrl,
//       method: "GET",
//       responseType: "blob", // Important for downloading files
//     })
//       .then((response) => {
//         const url = window.URL.createObjectURL(new Blob([response.data]));
//         const link = document.createElement("a");
//         link.href = url;
//         link.setAttribute("download", `template${id}.docx`); // or any other extension
//         document.body.appendChild(link);
//         link.click();
//         link.parentNode.removeChild(link);
//       })
//       .catch((error) => console.error("Download error:", error));
//   };

//   // const handleDownload = (id) => {
//   //   const fileUrl = `http://localhost:8189/api/PrintTemplates/download-template`;
//   //   fetch(fileUrl, {
//   //     method: "POST",
//   //     headers: {
//   //       // "Content-Type": "application/octet-stream",
//   //     },
//   //   })
//   //     .then((response) => response.blob())
//   //     .then((blob) => {
//   //       const url = window.URL.createObjectURL(new Blob([blob]));
//   //       const link = document.createElement("a");
//   //       link.href = url;
//   //       link.setAttribute("download", `template${id}.docx`); // or any other extension
//   //       document.body.appendChild(link);
//   //       link.click();
//   //       link.parentNode.removeChild(link);
//   //     })
//   //     .catch((error) => console.error("Download error:", error));
//   // };

//   const handleToggleState = (id) => {
//     // Logic to toggle the template state
//     console.log("Toggle state for template with ID:", id);
//   };

//   return (
//     <TableContainer component={Paper}>
//       <Table>
//         <TableHead>
//           <TableRow>
//             <TableCell>Template Name</TableCell>
//             <TableCell>Template Icon</TableCell>
//             <TableCell>State</TableCell>
//             <TableCell>Actions</TableCell>
//           </TableRow>
//         </TableHead>
//         <TableBody>
//           {templates.map((template) => {
//             const IconComponent = icons[template.icon];
//             return (
//               <TableRow key={template.id}>
//                 <TableCell>{template.name}</TableCell>
//                 <TableCell>{IconComponent && <IconComponent />}</TableCell>
//                 <TableCell>
//                   <Switch
//                     checked={template.enabled}
//                     onChange={() => handleToggleState(template.id)}
//                     color="primary"
//                   />
//                 </TableCell>
//                 <TableCell>
//                   <IconButton onClick={() => onEdit(template)}>
//                     <EditIcon />
//                   </IconButton>
//                   <IconButton onClick={() => handleDownload(template.id)}>
//                     <DownloadIcon />
//                   </IconButton>
//                 </TableCell>
//               </TableRow>
//             );
//           })}
//         </TableBody>
//       </Table>
//     </TableContainer>
//   );
// };

// export default TemplateTable;
